import { useCallback, useEffect, useState } from 'react';
import { GridColumns } from '@mui/x-data-grid';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useCondominiums, useFetch } from '../../hooks';
import useMarkets from '../../hooks/data/useMarkets';
import useStyles from './styles';
import Market from '../../entities/market.entity';
import MainContainer from '../../components/MainContainer';
import { DataTable } from '../../components';
import { useMarketContext } from '../../contexts/MarketContext';

interface UpdateButtonProps {
  value: Market;
}

const UpdateButton = ({ value }: UpdateButtonProps): JSX.Element => {
  const { handleSelectMarket } = useMarketContext();

  return (
    <IconButton onClick={() => handleSelectMarket(value)}>
      <Edit />
    </IconButton>
  );
};

const headers: GridColumns = [
  {
    field: 'label',
    headerName: 'Mercado',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    sortable: true,
    flex: 1,
  },
  {
    field: 'condominium',
    headerName: 'Condomínio',
    editable: false,
    flex: 1,
  },
  {
    field: 'marketCode',
    headerName: 'Código de vínculo',
    editable: false,
    flex: 1,
  },
  {
    field: 'operator',
    headerName: 'Operador',
    editable: false,
    flex: 1,
  },
  {
    field: 'action',
    headerName: 'Ações',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: (value) => <UpdateButton value={value.row} />,
    hideSortIcons: true,
  },
];

export const Markets = (): JSX.Element => {
  const styles = useStyles();
  const history = useNavigate();
  const repositoryMarket = useMarkets();
  const repositoryCondominium = useCondominiums();
  const { data: marketData, loading: loadingMarket } = useFetch(repositoryMarket.fetchAll);
  const { data: condominiumData, loading: loadingCondominium } = useFetch(repositoryCondominium.fetchAll);
  const [marketTable, setMarketTable] = useState<Market[]>([]);

  useEffect(() => {
    if (condominiumData && marketData) {
      setMarketTable(
        marketData.map((market) => ({
          ...market,
          condominium: condominiumData.find((condo) => condo.id === market.condominium)?.name ?? 'Sem condomínio',
        }))
      );
    }
  }, [marketData, condominiumData]);

  const handleCreate = useCallback(() => history('/markets/new'), [history]);

  if (loadingMarket || loadingCondominium) {
    return <></>;
  }

  return (
    <MainContainer>
      <div className={styles.content}>
        <DataTable
          columns={headers}
          rows={marketTable || []}
          loading={loadingMarket || loadingCondominium}
          showAddButton
          onClickAdd={handleCreate}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: 'label',
                  sort: 'asc',
                },
              ],
            },
          }}
        />
      </div>
    </MainContainer>
  );
};

export default Markets;
